module.exports = {"id":"139860","name":"Jérémy Morel","rating":"76","photo":"./data/images/photos/1/139860.png","club":{"name":"OL","logo":"./data/images/clubs/OL.png"},"positions":["DC","DG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JeremyMorel0.json
// module id = 1986
// module chunks = 0